import { CHANNELS } from "../../shared/channels";
import { LogEntry } from "../../shared/types";
import { call, listen } from "../bridge";
import { byId, cloneTemplate, fillFields, renderList } from "../dom";
import { onViewShown } from "../navigation";
import { locale, t } from "../i18n";

// live activity log with a chip per source to filter on

let entries: LogEntry[] = [];
let activeSource = "all";

function buildLine(entry: LogEntry): HTMLElement {
  const time = new Date(entry.time).toLocaleTimeString(locale(), { hour: "2-digit", minute: "2-digit", second: "2-digit" });
  const line = fillFields(cloneTemplate("template-log"), { time, source: entry.source, message: entry.message });
  line.classList.add(entry.level);
  return line;
}

function renderFilters(): void {
  const sources = ["all", ...new Set(entries.map((entry) => entry.source))];
  renderList(byId("logs-filters"), sources, (source) => {
    const chip = fillFields(cloneTemplate("template-filter-chip"), { name: source === "all" ? t("all") : source });
    chip.classList.toggle("active", source === activeSource);
    chip.addEventListener("click", () => {
      activeSource = source;
      render();
    });
    return chip;
  });
}

function render(): void {
  const visible = entries.filter((entry) => activeSource === "all" || entry.source === activeSource);
  // newest first so fresh problems are on top
  renderList(byId("logs-list"), [...visible].reverse(), buildLine);
  byId("logs-empty").hidden = entries.length > 0;
  renderFilters();
}

async function reload(): Promise<void> {
  entries = await call<LogEntry[]>(CHANNELS.logsList);
  render();
}

export async function setupLogsView(): Promise<void> {
  byId("logs-clear").addEventListener("click", async () => {
    await call(CHANNELS.logsClear);
    await reload();
  });

  listen<LogEntry>(CHANNELS.logsEntry, (entry) => {
    entries.push(entry);
    if (entries.length > 400) entries = entries.slice(-300);
    if (byId("view-logs").classList.contains("active")) render();
  });
  onViewShown("logs", reload);
}
